const translations = {
  ru: {
    title: 'Награды ждут',
    achShort: 'ач.',
    claim: 'Забрать',
    deposit: 'Пополнить',
    needMore: 'Пополни ещё',
    toClaim: 'чтобы забрать награды за ачивки',
    claimed: 'Награды забраны!',
    notClaimed: 'Награда не получена',
    coins: 'монет',
  },
  en: {
    title: 'Rewards waiting',
    achShort: 'ach.',
    claim: 'Claim',
    deposit: 'Top up',
    needMore: 'Top up',
    toClaim: 'more to claim your achievement rewards',
    claimed: 'Rewards claimed!',
    notClaimed: 'Reward not claimed',
    coins: 'coins',
  },
  uz: {
    title: 'Mukofotlar kutmoqda',
    achShort: 'yut.',
    claim: 'Olish',
    deposit: "To'ldirish",
    needMore: "Yana to'ldiring",
    toClaim: 'yutuq mukofotlarini olish uchun',
    claimed: 'Mukofotlar olindi!',
    notClaimed: 'Mukofot olinmagan',
    coins: 'tanga',
  },
};

export default translations;
